import Swiper, { Keyboard, Navigation, Pagination, Thumbs } from 'swiper';

/**
 * Vehicle image carousel class with modal and 360 image support.
 */
class VehicleImageCarousel {
  constructor(element) {
    this._carouselElement = element;

    // Image modal elements
    this._tabs = document.querySelectorAll('.vehicle-page-image-modal__tab');
    this._toggleInputs = document.querySelectorAll('input[name="vehicle-page-image-modal-toggle"]');

    // 360 image elements
    this._vehicle360Images = document.querySelector('.vehicle-360-images');
    this._imageContainer = this._vehicle360Images?.querySelector('.vehicle-360-images-container');
    this._toggleButton = this._vehicle360Images?.querySelector('.vehicle-360-images__toggle-container input[type="checkbox"]');

    // 360 image data attributes
    this._cloudpanoId = this._vehicle360Images?.getAttribute('data-id');
    this._outsideId = this._vehicle360Images?.getAttribute('data-outside-id');
    this._insideId = this._vehicle360Images?.getAttribute('data-inside-id');

    this._initSwiperCarousel();
    this._initModalButtonPress();
    this._initImageModalTabToggle();
    this._init360ImageToggle();
  }

  /**
   *
   * @param {string} view - 'inside' or 'outside'
   */
  _load360Image(view) {
    const viewId = view === 'inside' ? this._insideId : this._outsideId;
    const cloudpanoHTML = `<div id="${this._cloudpanoId}"><script type="text/javascript" async data-short=${this._cloudpanoId}?sceneId=${viewId}&disable=logo,sound,ribbon,request,controls,leadgen,floorplan,watermark,automotiveModes" data-path="tours" data-is-self-hosted="false" width="800px" height="500px" src="https://app.cloudpano.com/public/shareScript.js"></script></div>`;

    this._imageContainer.innerHTML = '';
    const scriptEl = document.createRange().createContextualFragment(cloudpanoHTML);
    this._imageContainer.append(scriptEl);
  }

  /**
   *
   * @param {string} tab - Tab name
   */
  _selectModalTab(tab) {
    Array.from(this._tabs).forEach((tabElement) => {
      if (tabElement.dataset.tab === tab) {
        tabElement.classList.add('active');
      } else {
        tabElement.classList.remove('active');
      }

      // Load 360 image if tab is selected and iframe is not present
      if (tabElement.dataset.tab === 'images-360' && !this._vehicle360Images.querySelector('iframe')) {
        this._load360Image('outside');
      }
    });
  }

  /**
   * Initialize 360 image toggle.
   */
  _init360ImageToggle() {
    if (this._toggleButton) {
      this._toggleButton.addEventListener('change', (e) => {
        if (e.target.checked) {
          this._load360Image('inside');
        } else {
          this._load360Image('outside');
        }
      });
    }
  }

  /**
   * Initialize image modal tab toggle.
   */
  _initImageModalTabToggle() {
    Array.from(this._toggleInputs).forEach((input) => {
      input.addEventListener('change', (e) => {
        this._selectModalTab(e.target.value);
      });
    });
  }

  /**
   * Initialize Swiper main carousel and thumbnail carousel.
   */
  _initSwiperCarousel() {
    const thumbnailSettings = {
      spaceBetween: 2,
      slidesPerView: 4,
      slideToClickedSlide: true,
      breakpoints: {
        992: {
          slidesPerView: 7,
        },
        768: {
          slidesPerView: 6,
        },
      },
    };

    const thumbnails = new Swiper('.vehicle-image-carousel-thumbnails', thumbnailSettings);

    const settings = {
      modules: [Keyboard, Navigation, Pagination, Thumbs],
      observer: true,
      observeParents: true,
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        prevEl: '.vehicle-image-carousel__prev',
        nextEl: '.vehicle-image-carousel__next',
      },
      pagination: {
        el: '.vehicle-image-carousel__pagination',
        type: 'fraction',
      },
      thumbs: {
        swiper: thumbnails,
      },
    };

    new Swiper('.vehicle-image-carousel', settings);
  }

  /**
   * Select active tab for image modal.
   */
  _initModalButtonPress() {
    const modalButtons = this._carouselElement.querySelectorAll('.js-open-image-modal');

    Array.from(modalButtons).forEach((button) => {
      const tab = button.dataset.tab;

      button.addEventListener('click', (e) => {
        if (tab) {
          this._selectModalTab(tab);

          Array.from(this._toggleInputs).forEach((input) => {
            if (input.value === tab) {
              input.checked = true;
            } else {
              input.checked = false;
            }
          });
        }
      });
    });
  }

  /*
    Initialize carousels.
  */
  static init() {
    document.querySelectorAll('.vehicle-image-carousel').forEach( element => new VehicleImageCarousel(element));
  }
}

export default VehicleImageCarousel;
